<template>
  <div class="flex justify-center">
    <div class="app-max-width" :class="slotClass">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  slotClass?: string
}>()
</script>
